// src/context/ThemeContext.js

import React, { createContext, useState, useEffect, useMemo } from 'react';

const THEME_KEY = 'appTheme'; // The key we'll use in localStorage
export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    // The useState initializer now runs a function to get the saved theme.
    // This happens only once on the initial render.
    const [darkMode, setDarkMode] = useState(() => {
        try {
            const storedTheme = localStorage.getItem(THEME_KEY);
            // If a theme is stored, use it. Otherwise, default to light mode (false).
            return storedTheme === 'dark';
        } catch (error) {
            console.error("Could not load theme from localStorage", error);
            return false;
        }
    });

    // This effect runs *every time* the darkMode state changes.
    // It saves the new preference to localStorage.
    useEffect(() => {
        localStorage.setItem(THEME_KEY, darkMode ? 'dark' : 'light');
    }, [darkMode]);

    const toggleDarkMode = () => {
        setDarkMode(prevMode => !prevMode);
    };

    // useMemo prevents unnecessary re-renders of consumer components
    const value = useMemo(() => ({ darkMode, toggleDarkMode }), [darkMode]);

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};
